import Navbar from "components/Navbar"
import PageContainer from "components/PageContainer"
import { useState } from "react"
import { useParams } from "react-router-dom"

import LeadBanner from "./Banner"
import BottomBar from "./BottomBar"
import { UserLeadProvider } from "./Context"
import Step1 from "./Step1"
import Step2 from "./Step2"
import Step3Footer from "./Step3/Components/Step3Footer"
import Step3 from "./Step3/Step3"

const totalSteps = 3

const Lead = () => {
  const { userId } = useParams()

  const [currentStep, setCurrentStep] = useState(1)

  return (
    <div className="bg-onSurface-50">
      <UserLeadProvider suraasaLeadId={userId}>
        <Navbar />
        <LeadBanner />
        <PageContainer className="pb-5">
          {currentStep === 1 && <Step1 />}
          {currentStep === 2 && <Step2 />}
          {currentStep === 3 && <Step3 setCurrentStep={setCurrentStep} />}
          {currentStep !== 3 && (
            <BottomBar
              totalSteps={totalSteps}
              currentStep={currentStep}
              setCurrentStep={setCurrentStep}
            />
          )}
        </PageContainer>
        {currentStep === 3 && <Step3Footer />}
      </UserLeadProvider>
    </div>
  )
}

export default Lead
